import ProgettoRiabilitativoIndividualeListPage from "./pages/ProgettoRiabilitativoIndividualeListPage.vue"
export default {
    ProgettoRiabilitativoIndividualeListPage
};
